import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Transition, Segment, Grid } from "semantic-ui-react";
import SearchField from "../shared/SearchField";
import { busquedasOps } from "../../ducks/busquedas";
import isEmpty from "lodash/isEmpty";

class Buscadores extends React.Component {
  componentDidMount() {
    this.props.fetchSearchDataEscuelas();
  }

  componentWillUnmount() {
    this.props.resetSearchDataEscuelas();
  }

  handleSearchFieldAction = (field, { busqueda }) => {
    let resultado = null;

    switch (field) {
      case "buscarColegio":
        resultado = this.props.searchByColegio.filter(
          ({ childKey }) => childKey === busqueda
        )[0];
        !isEmpty(resultado) &&
          this.props.history.push(`/preinscripciones/${resultado.childKey}`);
        return;

      case "buscarNombre":
        resultado = this.props.searchByNombre.filter(
          item => item.childKey === busqueda
        )[0];
        break;

      case "buscarResguardo":
        resultado = this.props.searchByResguardo.filter(
          item => item.childKey === busqueda
        )[0];
        break;

      default:
        break;
    }

    !isEmpty(resultado) &&
      this.props.history.push(
        resultado.confirmado === "si"
          ? `/inscripciones-confirmadas/${resultado.colegio}/${
              resultado.childKey
            }`
          : `/preinscripciones/${resultado.colegio}/${resultado.childKey}`
      );
  };

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.props.visible &&
          !isEmpty(this.props.searchByNombre) &&
          !isEmpty(this.props.searchByResguardo) &&
          !isEmpty(this.props.searchByColegio) && (
            <Segment textAlign="center">
              <Grid columns={3}>
                <Grid.Row>
                  <Grid.Column>
                    <SearchField
                      form="SearchEscuelasNombreForm"
                      fieldID="buscarNombre"
                      fieldName="busqueda"
                      labelText="Búsqueda por Nombre"
                      placeholder="Nombre del Alumno"
                      handleButtonClick={this.handleSearchFieldAction}
                      datosBusqueda={this.props.searchByNombre}
                      showAddButton={false}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <SearchField
                      form="SearchEscuelasResguardoForm"
                      fieldID="buscarResguardo"
                      fieldName="busqueda"
                      labelText="Búsqueda por Resguardo"
                      placeholder="Número de resguardo"
                      handleButtonClick={this.handleSearchFieldAction}
                      datosBusqueda={this.props.searchByResguardo}
                      showAddButton={false}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <SearchField
                      form="SearchColegioEscuelasForm"
                      fieldID="buscarColegio"
                      fieldName="busqueda"
                      labelText="Búsqueda por Colegios"
                      placeholder="Nombre del Colegio"
                      handleButtonClick={this.handleSearchFieldAction}
                      datosBusqueda={this.props.searchByColegio}
                      showAddButton={false}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
          )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  searchByNombre: state.busquedas.searchByNombre,
  searchByResguardo: state.busquedas.searchByResguardo,
  searchByColegio: state.busquedas.searchByColegio
});

const actions = {
  fetchSearchDataEscuelas: busquedasOps.fetchSearchDataEscuelas,
  resetSearchDataEscuelas: busquedasOps.resetSearchDataEscuelas
};

export default connect(mapStateToProps, actions)(withRouter(Buscadores));



// WEBPACK FOOTER //
// ./src/pages/escuelas/Buscadores.jsx